/** Tonalités V2 partagées (soft bg + texte AA) - branchées sur les tokens --v2-*. */
export type V2Tone = 'neutral' | 'brand' | 'accent' | 'ok' | 'warn' | 'err'

export const toneSoftClass: Record<V2Tone, string> = {
  neutral: 'bg-[var(--v2-bg-soft)] text-[var(--v2-ink-3)] border-[var(--v2-line)]',
  brand: 'bg-[var(--v2-brand-soft)] text-[var(--v2-brand-ink)] border-[var(--v2-brand-soft)]',
  accent: 'bg-[var(--v2-accent-soft)] text-[var(--v2-accent-2)] border-[var(--v2-accent-soft)]',
  ok: 'bg-[var(--v2-ok-soft)] text-[var(--v2-ok)] border-[var(--v2-ok-soft)]',
  warn: 'bg-[var(--v2-warn-soft)] text-[var(--v2-warn)] border-[var(--v2-warn-soft)]',
  err: 'bg-[var(--v2-err-soft)] text-[var(--v2-err)] border-[var(--v2-err-soft)]',
}
